//----------------------------------------------------------
// Custom Journey CTA Test
//----------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() {

    const customPacketModal = document.querySelector('#inline-legal-modal');
    const customPacketButton = document.querySelector('.js-modal-radio-confirm');

    customPacketButton?.addEventListener('click', function(e) {
        e.preventDefault();
        // check validation - this function confirms the next steps taken
        if (validateCustomPacketRadios()) {
            buildModalStep();
        } else {
            showPacketValidationErrors('.js-primary-modal-options');
        }
    });

    // On Radio click event
    document.addEventListener('change', function(e) {
        if (e.target.matches('.js-modal-radio')) {
            // remove any errors labels if found
            clearValidationErrors();
            // remove all checked radios
            let radios = document.querySelectorAll('.js-modal-radio');
            radios.forEach(radio => radio.checked = false);
            // add radio to only the one that was clicked
            e.target.checked = true;
        }
    });

    // Validation of radio options
    function validateCustomPacketRadios() {
        clearValidationErrors();
        // If no radio has been selected the var checkedRadios will return false
        let checked = Array.from(document.querySelectorAll(".js-modal-radio")).some(el => el.checked);
        if (checked) {
            // A radio was found
            return true;
        } else {
            // No radio button has been selected so update the dom to let the user know
            return false;
        }
    }

    // Show the errors in the dom
    function showPacketValidationErrors(target) {
        let errorElement = document.createElement('p');
        errorElement.classList.add('js-modal-validate');
        errorElement.style.color = 'red';
        errorElement.textContent = 'Please make a selection to continue.';
        let parentElement = document.querySelector(target);
        parentElement.parentNode.insertBefore(errorElement, parentElement);
    }

    // Remove errors from the dom
    function clearValidationErrors() {
        // Note this will need to be updated depending on what errors actually look like
        let errors = document.querySelectorAll(".js-modal-validate");
        errors.forEach(error => error.remove());
    }

    // Build out the modal and show it to the user
    function buildModalStep() {
        // get the selected radios value to determine what to show next
        var selectedRadio = document.querySelector(".js-modal-radio:checked");
        const modalForm = document.querySelector('.js-modal-step-form .c-form');
        modalForm.querySelector('input[name="effect"]').value = selectedRadio.name;

        if (selectedRadio.dataset.modalOptions) {
            let modalOptions = selectedRadio.dataset.modalOptions.split(',');
            optionBuild(modalOptions);
        }
        openModalStep(selectedRadio.dataset.modalStep);
    }

    function openModalStep(step) {
        let modals = document.querySelectorAll(".js-modal-step");
        modals.forEach(modal => modal.style.display = 'none'); // fadeOut equivalent
        let targetModal = document.querySelector('.js-' + step);
        targetModal.style.display = ''; // fadeIn equivalent
        targetModal.classList.add('current');
        openPopUp();
    }

    function nextModalStep(step) {
        let currentModal = document.querySelector(".js-modal-step.current");
        currentModal.style.display = 'none'; // fadeOut equivalent
        currentModal.classList.remove('current');
        let nextModal = document.querySelector('.js-' + step);
        nextModal.style.display = ''; // fadeIn equivalent
        nextModal.classList.add('current');
    }

    //=====> Runs Regular option Function
    function optionBuild(options) {
        var buildOptionsHTML = "";
        options.forEach(function(data) {
            buildOptionsHTML += `<li><input class="js-modal-option" type="checkbox" name="choices[]" id="${data}" value="${data}">
            <label for="${data}">${data}</label></li>`;
        });
        // add the modal radios
        document.querySelector(".js-modal-option-build").innerHTML = buildOptionsHTML;
    }

    function openPopUp() {
        customPacketModal?.querySelector('.c-modal')?.classList.add('c-cpb-modal', 'c-cpb-legal', 'js-customTrackingData');

        MicroModal.show('inline-legal-modal', {
            disableScroll: true
        });

        document.querySelector('#inline-legal-modal').querySelector(".mfp-wrap").style.overflow = "hidden auto";
    }

    document.addEventListener('click', function(e) {
        if (e.target.matches('.js-yes-rs')) {
            document.querySelector('.js-modal-step-form input[name="requested_service_detail"]').value = "Find a Specialist";
        }
    });

    document.addEventListener('click', function(e) {
        if (e.target.matches('.js-options-select')) {
            let selectedOptions = document.querySelectorAll(".js-modal-option:checked"),
                requested_service_detail = document.querySelector('.js-modal-step-form input[name="requested_service_detail"]'),
                optionText = [];

            selectedOptions.forEach(option => {
                optionText.push(option.value);
            });

            if (requested_service_detail.value != "") {
                requested_service_detail.value += ", ";
            }

            requested_service_detail.value += optionText.join(", ");
        }
    });

    document.addEventListener('click', function(e) {
        const nextModalStepElement = e.target.closest('.js-next-modal-step');

        if (nextModalStepElement) {
            e.preventDefault();
            clearValidationErrors();
        
            if (nextModalStepElement.closest('.js-modal-step-options') && !document.querySelector(".js-modal-option:checked")) {
                showPacketValidationErrors('.js-modal-option-build');
            } else {
                if (nextModalStepElement.dataset.modalOptions) {
                    let modalOptions = nextModalStepElement.dataset.modalOptions.split(',');
                    optionBuild(modalOptions);
                }
                if (nextModalStepElement.dataset.modalStep == "modal-step-options") {
                    let requested_service_detail = document.querySelector('.js-modal-step-form input[name="requested_service_detail"]');
                    if (requested_service_detail.value.startsWith("Find a Specialist")) {
                        requested_service_detail.value = "Find a Specialist";
                    } else {
                        requested_service_detail.value = "";
                    }
                }
                nextModalStep(nextModalStepElement.dataset.modalStep);
            }
        }
        
    });

    // Remove validation errors on checkbox change
    document.addEventListener('change', function(e) {
        if (e.target.matches('.js-modal-option')) {
            clearValidationErrors();
        }
    });
});
